/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MerchantSearchResult } from './MerchantSearchResult';
import {
    MerchantSearchResultFromJSON,
    MerchantSearchResultFromJSONTyped,
    MerchantSearchResultToJSON,
    MerchantSearchResultToJSONTyped,
} from './MerchantSearchResult';

/**
 * 
 * @export
 * @interface GetOrderAgainMerchantsResponse
 */
export interface GetOrderAgainMerchantsResponse {
    /**
     * 
     * @type {Array<MerchantSearchResult>}
     * @memberof GetOrderAgainMerchantsResponse
     */
    merchants: Array<MerchantSearchResult>;
}

/**
 * Check if a given object implements the GetOrderAgainMerchantsResponse interface.
 */
export function instanceOfGetOrderAgainMerchantsResponse(value: object): value is GetOrderAgainMerchantsResponse {
    if (!('merchants' in value) || value['merchants'] === undefined) return false;
    return true;
}

export function GetOrderAgainMerchantsResponseFromJSON(json: any): GetOrderAgainMerchantsResponse {
    return GetOrderAgainMerchantsResponseFromJSONTyped(json, false);
}

export function GetOrderAgainMerchantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrderAgainMerchantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'merchants': ((json['merchants'] as Array<any>).map(MerchantSearchResultFromJSON)),
    };
}

export function GetOrderAgainMerchantsResponseToJSON(json: any): GetOrderAgainMerchantsResponse {
    return GetOrderAgainMerchantsResponseToJSONTyped(json, false);
}

export function GetOrderAgainMerchantsResponseToJSONTyped(value?: GetOrderAgainMerchantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'merchants': ((value['merchants'] as Array<any>).map(MerchantSearchResultToJSON)),
    };
}

